import { CONFIG } from "../../appConfig";

/**
 * @desc status endpoint
 * @returns {Object}
 * @memberof services.gma.status
 */
export default {
  status() {
    return {
      method: "GET",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: 'status'
    };
  }
};